module.exports = __webpack_public_path__ + "img/9791195189311.555e37d5.jpg";